module.exports = __webpack_public_path__ + "static/img/nation.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/common/nation.png
// module id = pF+J
// module chunks = 10